import gql from 'graphql-tag';

export class UploadFileMutations {
  static getUploadFilesUrlsMutation = gql`
    mutation GetUploadFilesUrls($documentId: String!, $filenames: [String!]!) {
      getUploadFilesUrls(documentId: $documentId, filenames: $filenames) {
        uniqueFilename
        uploadUrl
      }
    }
  `;

  static uploadFilesDoneMutation = gql`
    mutation UploadFilesDone($documentId: String!, $index: Int!, $uniqueFilenames: [String!]!) {
      uploadFilesDone(documentId: $documentId, index: $index, uniqueFilenames: $uniqueFilenames)
    }
  `;

  static uploadFilesDoneV2 = gql`
    mutation UploadFilesDoneV2($args: [UploadFilesDoneArgsInput!]!, $jobType: JobType!) {
      uploadFilesDoneV2(args: $args, jobType: $jobType)
    }
  `;
}
